import { AuthorizedBaseAxios, BaseAxios, flatten } from 'src/config/axios';
import {
  ConsentDTO,
  ConsentParams,
} from 'src/pages/MainPage/components/ConsentForm/consentModels';
import { ListWrapper, unwrap } from '@summer/react-kit';
import { sortBy, pipe } from 'ramda';
import { useMutation, useQuery } from '@tanstack/react-query';
import { ProcessDTO } from 'src/common/models/processModels';
import { verificationQueryKeys } from 'src/common/verificationQueryKeys';
import { publicApiPath } from 'src/common/publicApiPath';

export const getListOfConsents = (verificationId?: string) =>
  BaseAxios.get<ListWrapper<ConsentDTO>>(
    `${publicApiPath}/businessconsent/${verificationId}`
  ).then(
    pipe(flatten, unwrap, (consents: ConsentDTO[]) =>
      sortBy((x) => x.order, consents)
    )
  );

export const useConsentsQuery = (verificationId?: string) =>
  useQuery(verificationQueryKeys.consents(verificationId), () =>
    getListOfConsents(verificationId)
  );

interface StartPublicProcessParams {
  businessConsent: ConsentParams[];
  verificationId: string;
  relatedProcessUUID?: string; //verificationId
}

const sendConsentsListAndStartProcess = (params: StartPublicProcessParams) =>
  AuthorizedBaseAxios.post<ProcessDTO>(`${publicApiPath}/consent`, params).then(
    flatten
  );

export const useAcceptConsentsMutation = () =>
  useMutation((params: StartPublicProcessParams) =>
    sendConsentsListAndStartProcess(params)
  );
